import { metricsStore } from '@globalStore/metricsStore';
import { getMetricCategoryOrder } from '@utils/metrics/utilities';

function useMetricCategoryOrder(supportedMetrics) {
  const { metricsCategoryMeta } = metricsStore.getState();
  const currentCategories = Object.keys(supportedMetrics);
  const metricCategoryOrder = getMetricCategoryOrder(metricsCategoryMeta);
  const orderedCategories = metricCategoryOrder.filter((category) =>
    currentCategories.includes(category),
  );
  return orderedCategories;
}

export default useMetricCategoryOrder;
